import { mobileButton } from './mobileButton'
import { mobilePicker } from './mobilePicker'
import { mobileDatePicker } from './mobileDatePicker'
import { mobileImage } from './mobileImage'
import { mobileText } from './mobileText'
import { mobileTextInput } from './mobileTextInput'
import { mobileSwitch } from './mobileSwitch'
import { mobileVideoPlayer } from './mobileVideoPlayer'

export const mobuiDefinitionsByType = {
  '$w.MobileButton': mobileButton,
  '$w.MobilePicker': mobilePicker,
  '$w.MobileDatePicker': mobileDatePicker,
  '$w.MobileImage': mobileImage,
  '$w.MobileText': mobileText,
  '$w.MobileTextInput': mobileTextInput,
  '$w.MobileSwitch': mobileSwitch,
  '$w.MobileVideoPlayer': mobileVideoPlayer,
}
